import React from 'react';
import {useGetItemDetailsQuery} from "../../store/Api";
import DetailsModal from "./DetailsModal";
import {IActiveDestination} from "../../models/Destination";

interface IProductIdModalProps {
    catalog: string;
    productId: string;
    onDismiss: (id: string | undefined) => void;
    /** Makes the modal's Add button default to this destination (split button; other destinations in the menu). */
    addToDestination?: IActiveDestination;
    initialTab?: 'details' | 'media' | 'vendor' | 'purchaseHistory';
}

const ProductIdModal: React.FC<IProductIdModalProps> = (props) => {
    const dismiss = () => {
        props.onDismiss(undefined);
    }
    
    return (<DetailsModal product={props.productId} catalog={props.catalog} open={true} onClose={dismiss} addToDestination={props.addToDestination} initialTab={props.initialTab} />);
}

export default ProductIdModal;